const STORAGE_KEY = 'skymp5-chat-preferences';

export function loadChatPreferences() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
}

export function saveChatPreferences(partial) {
  try {
    const current = loadChatPreferences();
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...current, ...partial }));
  } catch (e) { }
}
